import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEnvelope } from "@fortawesome/free-regular-svg-icons"

import { SupportRequestForm, SupportRequestFormCanvas } from "./component"

export default {
  id: "support-request-form",
  block: {
    category: "SQS",
    icon: <FontAwesomeIcon size="3x" icon={faEnvelope} />,
    label: "SQS support request form",
  },
  props: [],
  component: SupportRequestForm,
  canvas: SupportRequestFormCanvas,
  components: [],
  styles: {
    position: "relative",
  },
}
